export default __webpack_public_path__ + "static/media/Seller_Reading3.d835fd38.png";